var _a;
export var ValidationTypes = /*#__PURE__*/ function (ValidationTypes) {
    ValidationTypes["number"] = "number";
    ValidationTypes["noSpace"] = "noSpace";
    ValidationTypes["onlyAlphabets"] = "onlyAlphabets";
    ValidationTypes["bothStringNumber"] = "bothStringNumber";
    ValidationTypes["decimalNumber"] = "decimalNumber";
    ValidationTypes["email"] = "email";
    ValidationTypes["countryCode"] = "countryCode";
    ValidationTypes["mobile"] = "mobile";
    ValidationTypes["urlPath"] = "urlPath";
    ValidationTypes["password"] = "password";
    ValidationTypes["gstCode"] = "gstCode";
    ValidationTypes["ifsc"] = "ifsc";
    ValidationTypes["uuid"] = "uuid";
    return ValidationTypes;
}({});
export var Regex = {
    number: /^\d+$/,
    // Matches one or more digits
    mobile: /^\d{10}$/,
    // Matches mobile numbers with optional country code
    decimalNumber: /^\d+(\.\d+)$/,
    // Matches decimal numbers
    noSpace: /^\S+$/,
    // Matches any string without spaces
    onlyAlphabets: /^[A-Za-z\s]+$/,
    // Matches only alphabets and spaces
    bothStringNumber: /^[A-Za-z0-9]+$/,
    // Matches both letters and numbers
    email: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
    // Matches email addresses
    countryCode: /^\+\d{1,3}$/,
    // Matches country codes with a plus sign followed by 1-3 digits
    urlPath: /^(https?:\/\/)?([\w-]+(\.[\w-]+)+)(\/[\w-]*)*\/?$/,
    // Matches URL paths
    password: /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[#?!@$%^&*-]).{8,}$/,
    // Matches passwords with at least one uppercase, one lowercase, one digit, one special character, and minimum 8 characters
    gstCode: /^\d{2}[A-Z]{5}\d{4}[A-Z]{1}[A-Z\d]{1}[Z]{1}[A-Z\d]{1}$/,
    // Matches Indian GSTIN numbers
    ifsc: /^[A-Z]{4}0[A-Z0-9]{6}$/,
    // Matches Indian IFSC codes
    uuid: /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$/ // Matches 8-4-4-4-12 format uuid
};
export var ErrorText = (_a = {
        required: 'This field is required',
        invalid: 'Invalid Input',
        date: 'Please select valid date'
    },
    _a[ValidationTypes.number] = 'Please enter only whole numbers',
    _a[ValidationTypes.decimalNumber] = 'Please enter only decimal numbers',
    _a[ValidationTypes.onlyAlphabets] = 'Numbers not allowed',
    _a[ValidationTypes.bothStringNumber] = 'Please enter only letters and numbers, without spaces or special characters',
    _a[ValidationTypes.email] = 'Please enter valid email',
    _a[ValidationTypes.mobile] = 'Please enter valid mobile number',
    _a[ValidationTypes.countryCode] = 'Please enter valid country code',
    _a[ValidationTypes.noSpace] = 'Space is not allowed',
    _a[ValidationTypes.urlPath] = "Please enter a valid path matching pattern '/path?query=search'",
    _a[ValidationTypes.password] = "The password should be at least 8 characters long, should contain at least one uppercase letter, one lowercase letter, one number and one special character.",
    _a[ValidationTypes.gstCode] = 'Value must be greater than or equal to 6 digits and less than 21 digits excluding space and special characters',
    _a[ValidationTypes.ifsc] = 'Invalid IFSC code',
    _a);
export var regexValidator = function (input, regex) {
    return regex.test(input);
};
